export const CONFIRM_ORDER_ADDR = 'CONFIRM_ORDER_ADDR'// 生成订单的地址
export const CONFIRM_ORDER_CARTLIST = 'CONFIRM_ORDER_CARTLIST'// 生成订单的商品列表
export const CONFIRM_ORDER_CYCOUNT = 'CONFIRM_ORDER_CYCOUNT'// 生成订单总费用
export const CONFIRM_ORDER_TOTAL = 'CONFIRM_ORDER_TOTAL'// 生成订单总费用
export const SEARCH_GOODS_LIST = 'SEARCH_GOODS_LIST'// 搜索商品的列表
export const SET_IS_SHOW_QRCODE = 'SET_IS_SHOW_QRCODE'// 是否显示二维码弹框



// WEBPACK FOOTER //
// ./src/store/mutation-types.js